/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Metadata } from '../models/Metadata';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class MetadataControllerService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * @param id
     * @returns Metadata Metadata
     * @throws ApiError
     */
    public getMetadataById(
        id: string,
    ): CancelablePromise<Metadata> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/metadata/{id}',
            path: {
                'id': id,
            },
            errors: {
                404: `Metadata not found`,
            },
        });
    }
}
